import { useNavigate } from "react-router";
import { hasSomewhereToGoBack } from "../../../Routes/hasSomewhereToGoBack";

// The hub hands the user over across origins, so there is no history behind a cold load.
export function useQueueBack(fallback: string): () => void {
  const navigate = useNavigate();

  return () => {
    if (hasSomewhereToGoBack()) {
      void navigate(-1);
      return;
    }
    const target = new URL(fallback, window.location.origin);
    if (target.origin === window.location.origin) {
      // Replace, or going "back" would keep growing the stack it is meant to unwind.
      void navigate(`${target.pathname}${target.search}${target.hash}`, { replace: true });
    } else {
      window.location.replace(target.href);
    }
  };
}
